module.exports = "/assets/images/hero-illustration.png";